const ExcludeNavbar = (props) => {
    return (
        <div style={{height:"110px"}} className={props.tluiGova ? "excludeNav":""}></div>
    )
}
export default ExcludeNavbar